import "./App.css"

import Banner from "./components/banner/Banner";
import BtnDownload from "./components/Buttons/Buttons";
import Cardproduto from "./components/cardProduto/CardProduto";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Menu/Menu";
import NoticeSection from "./components/NoticeSection/NoticeSection";
import RepresentanteSection from "./components/RepresentanteSection/RepresentanteSection";
import SectionEco from "./components/SectionEco/SectionEco";
import SectionHistoria from "./components/SectionHistoria/SectionHistoria";
import SocialMediaSection from "./components/SocialMediaSection/SocialMediaSection";
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import Slider from "./components/Slide/Slide";
import Premio from "./components/Premio/Premio";

function App() {

  return (
    <div className="App">
      <Navbar />
      <Banner />
      <div className="sectionLinhas">
        <div className="titleSection">
          <h1>Nossos <strong>Produtos</strong></h1>
          <p>Conheça nossos produtos,
            suas linhas e variedades.</p>
        </div>
        <div className="Linhas">
          <Slider />
        </div>
        <div className="btnCata">
          <a class="btnBaixar" href="../../assets/catalogo-cia-canoinhas.pdf" download="catalogo-cia-canoinhas.pdf">
            <i class="icon">
              <span class="material-symbols-outlined">
                enable
              </span>
            </i>Baixar Catálogo</a>
        </div>

      </div>


      <div>
        <SectionHistoria />
        <RepresentanteSection />
        <div className="Premios">
          <div className="titleSection">
            <h1>Premiações e  <strong>Certificados</strong></h1>
            <p style={{ marginBottom: "2rem" }}> Reconhecimento de Qualidade e Sucesso.</p>
          </div>
          <Premio />
        </div>
        <SocialMediaSection />
        <div className="titleNoticeSection">
          <h1>Notícias</h1>
          <p>Confira as últimas notícias em alta</p>
        </div>
        <NoticeSection />
        <Footer />
      </div>
    </div >
  );
}

export default App;
